<!-- Three equal columns give the 2:1 split: lead and main span two, the aside one.
     Auto-placement puts the aside in the third column of the first row.
     The `@2xl` prefix measures this component, not the window. -->
<div
  class="lp-detail-split-layout__grid dm-grid dm-grid-cols-1 dm-gap-48 @2xl:dm-grid-cols-3 @2xl:dm-gap-horizontal-32 @2xl:dm-gap-vertical-64"
>
  <div class="dm-min-w-0 @2xl:dm-grid-col-span-2">
    <ng-content select="[lead]" />
  </div>

  <!-- Sticky once the columns split, so the properties stay put while the main column scrolls. -->
  <aside #asideColumn class="lp-detail-split-layout__aside dm-min-w-0 @2xl:dm-grid-row-span-2">
    <ng-content select="[aside]" />
  </aside>

  <div class="dm-min-w-0 @2xl:dm-grid-col-span-2">
    <ng-content />
  </div>
</div>
